import { BACKEND_PUBLIC } from '../base'

export async function getLandingData(vacancyLimit?: number) {
  return BACKEND_PUBLIC.get<LX.LandingData>('/site/landing-data', { params: { vacancyLimit } })
}

export async function getLandingCopyData() {
  return BACKEND_PUBLIC.get<LX.LandingData>('/site/landing-data-2')
}
